import classNames from 'classnames';

import { getMediaUrl } from 'utils/assets';
import useLayout from 'utils/layout';
import { Translation } from 'utils/translations';

import styles from './EmptyState.module.scss';

const ErrorEmptyState = () => {
  const layout = useLayout();

  return (
    <div
      className={classNames(
        styles['error-empty-state-container'],
        styles[layout],
      )}
    >
      <img
        src={getMediaUrl('/yellow/game-error.webp')}
        alt="empty state"
        className={styles['error-empty-state-image']}
      />
      <p className={styles['error-empty-state-text']}>
        <Translation message="reload_page" />
      </p>
    </div>
  );
};

export default ErrorEmptyState;
